import { useAuthContext } from 'noddi-web';
import { useEffect, useRef } from 'react';
import { useUserGroupSelection } from './useUserGroupSelection';

/** Align navigation once; proposal requests keep their own group after later account switches. */
export const useProposalUserGroupSync = ({ proposalId, userGroupId }: { proposalId: number; userGroupId: number }) => {
  const { isLoggedIn, userData } = useAuthContext();
  const { selectUserGroup, selectableUserGroups } = useUserGroupSelection();
  const syncedContext = useRef<string | undefined>(undefined);
  const userId = userData?.user.id;
  const isMember = selectableUserGroups.some((group) => group.id === userGroupId);

  useEffect(() => {
    const context = `${proposalId}:${userGroupId}:${userId}`;
    if (!isLoggedIn || !isMember || syncedContext.current === context) {
      return;
    }
    syncedContext.current = context;
    selectUserGroup(userGroupId, { keepBookingDrafts: true });
    // eslint-disable-next-line react-hooks/exhaustive-deps -- selection aligns navigation once per proposal and signed-in user
  }, [isLoggedIn, isMember, proposalId, userGroupId, userId]);
};
